import { toast } from 'react-toastify'

export const displayToast = (type: string, message: string) => {
    const options = {
        theme: 'colored' as const,
        position: 'bottom-center' as const
    };
    
    switch(type){
        case 'success':
            return toast.success(message, options)
        case 'error':
            return toast.error(message, options)
        case 'warning':
            return toast.warn(message, options)
        case 'default':
            return toast(message, options)
        default:
            return toast(message, options)
    }
}